import CodeMirror from 'codemirror';
import { IModelField, IModelObjectFields } from '../../index.d';
import { mathModelField } from '../../../utils/fqn';
import { getPrevEffectiveToken, hasTokenIncludes } from '../../utils/codemirror';


export function matchModelPathHint({ editor, position, models }: {
  editor: CodeMirror.Editor,
  position: CodeMirror.Position,
  models: IModelField[]
}) {
  try {
    const currentToken = editor.getTokenAt(position);
    // console.log(currentToken);

    if (hasTokenIncludes(currentToken, ['dot'])) {
      const prevToken = getPrevEffectiveToken(editor, currentToken)!;
      if (hasTokenIncludes(prevToken, ['model-path'])) {
        const modelPath = prevToken.type!.split(' ').find(t => t.startsWith('path:'))!.slice(5);

        // console.log(modelPath);
        // console.log(prevToken);

        const ppToken = getPrevEffectiveToken(editor, prevToken!)!;
        const pppToken = getPrevEffectiveToken(editor, ppToken!)!;
        if (hasTokenIncludes(pppToken, ['model'])) {
          const model = pppToken.type!.split(' ').find(t => t.startsWith('model:'))!.slice(6);
          // console.log(model, modelPath);

          const modelObj = models.find(item => item.fqn === model);
          if (modelObj) {
            const { fields } = mathModelField(modelObj, modelPath) as IModelField || { fields: undefined };
            if (fields) {
              return {
                beingReplaced: 0,
                hints: getModelFieldKeys(fields).map(field => {
                  return { text: field, displayText: field };
                })
              };
            }
          }
        }
      }

    } else if (hasTokenIncludes(currentToken, ['bracket'])) {
      const prevToken = getPrevEffectiveToken(editor, currentToken)!;
      if (hasTokenIncludes(prevToken, ['model'])) {
        const model = prevToken.type!.split(' ').find(t => t.startsWith('model:'))!.slice(6);

        const modelObj = models.find(item => item.fqn === model);
        if (modelObj) {
          const { fields } = modelObj;
          if (fields) {
            return {
              beingReplaced: 0,
              hints: getModelFieldKeys(fields).map(field => {
                return { text: field, displayText: field };
              })
            };
          }
        }
      }
    } else if (currentToken.type === null && /^\s+$/.test(currentToken.string)) {
      const prevToken = getPrevEffectiveToken(editor, currentToken)!;
      if (hasTokenIncludes(prevToken, ['bracket'])) {
        const ppToken = getPrevEffectiveToken(editor, prevToken)!;
        if (hasTokenIncludes(ppToken, ['model'])) {
          const model = ppToken.type!.split(' ').find(t => t.startsWith('model:'))!.slice(6);

          const modelObj = models.find(item => item.fqn === model);
          if (modelObj) {
            const { fields } = modelObj;
            if (fields) {
              return {
                beingReplaced: 1,
                hints: getModelFieldKeys(fields).map(field => {
                  return { text: field, displayText: field };
                })
              };
            }
          }
        }
      }
    } else if (hasTokenIncludes(currentToken, ['model-path'])) {
      const prevToken = getPrevEffectiveToken(editor, currentToken)!;
      if (hasTokenIncludes(prevToken, ['bracket'])) {
        const ppToken = getPrevEffectiveToken(editor, prevToken)!;
        if (hasTokenIncludes(ppToken, ['model'])) {
          const model = ppToken.type!.split(' ').find(t => t.startsWith('model:'))!.slice(6);
          const modelPaths = currentToken.string.split('.');
          const modelPath = modelPaths.slice(0, -1).join('.');
          const matchPath = modelPaths[modelPaths.length - 1];

          const modelObj = models.find(item => item.fqn === model);
          if (modelObj) {
            const { fields } = (!modelPath ? modelObj :
              (mathModelField(modelObj, modelPath) as IModelField) || { fields: undefined });
            if (fields) {
              return {
                beingReplaced: 1,
                hints: getModelFieldKeys(fields, matchPath).map(field => {
                  return {
                    text: modelPath ? modelPath + '.' + field : field,
                    displayText: field
                  };
                })
              };
            }
          }
        }
      }
    }


  } catch (err) {
    return false;
  }
}



function getModelFieldKeys(fields: IModelObjectFields, keyword: string = '') {
  return Object.keys(fields).reduce((result, key) => {
    const field = fields[key];
    if (key.includes(keyword)) {
      result.push(key);
      if (field.type === 'Object' && field.isArray) {
        result.push(key + '[]');
      }
    }
    return result;
  }, [] as string[]);
}
